/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [
  {
    name: '轮播导航',
    type: 'module-name',
  },
  {
    key: 'margin_num',
    name: '左右间距',
    type: 'slider',
  },
  {
    key: 'bg_color',
    name: '背景色',
    type: 'color',
  },
  {
    key: 'link_data',
    name: '导航',
    type: 'swiper-nav',
  },
];

export default config;
